import React, { useState, useEffect } from 'react';
import { Typography, Grid2 } from '@mui/material';
// import { httpRequest } from '../../ui-utils/api';
import moment from 'moment';
import loadergif from '../../Assets/Images/app_downloads_loader.gif';
import styles from './IssueDisclosures.module.css';
import axios from 'axios';
import DocumentMeta from 'react-document-meta'

const meta = {
    title: 'Issue Disclosures | NSE, BSE & IPO Transparency | TradeBoss',
    description: 'Access TradeBoss issue disclosures for stocks, bonds & IPOs. Stay compliant with NSE, BSE regulations and make informed investments.',
    canonical: 'https://tradeboss.co/holiday_calendar, https://tradeboss.co/circular,  https://tradeboss.co/issue_disclosures, https://tradeboss.co/bulletin',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'IPO issue disclosures, stock issue disclosure, bond issue disclosures, regulatory disclosures India, issue prospectus information'
        }
    }
}
const IssueDisclosures = () => {
    const [userdata, setUserdata] = useState([]);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoad(true);
            try {

                  const cir_data = await axios.get(`https://bullforce-trader-admin-backend.bullforce.co/api/disclosures/list`)

                const formattedData = cir_data.data.data.map(data => ({
                    date: moment(data.date).format('DD/MM/YYYY'),
                    category: data.category,
                    title: data.title,
                    description: data.description
                }));

                setUserdata(formattedData);
            } catch (error) {
                console.log('An Error Occurred', error);
            } finally {
                setLoad(false);
            }
        };

        fetchData();
    }, []);

    return (
        <div className={styles.mainIssCard}>
            <DocumentMeta {...meta} />
            <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                {load ? (
                    <div className={styles.loaderContainer}>
                        <img src={loadergif} alt="loading..." className={styles.loaderImage} />
                    </div>
                ) : (
                    <Grid2 className={styles.issueCard1}>
                        {userdata.map((label, index) => (
                            <Grid2 key={index} className={styles.disclosureItem}>
                                <Grid2 className={styles.issCard1}>
                                    <Typography className={styles.titLabelDate} style={{ textAlign: 'center' }}>
                                        {label.date}
                                    </Typography>
                                    <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                        <Grid2 className={styles.categoryBadge}>
                                            <Typography className={styles.titLabelCat} sx={{ whiteSpace: "normal", textAlign: "justify", lineHeight: "1.5" }}>
                                                {label.category}
                                            </Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>
                                <Grid2 className={styles.issCard2}>
                                    <Typography className={styles.titLabel1} sx={{whiteSpace: "normal",textAlign: "justify",lineHeight: "1.5" }}>
                                        {label.title}
                                    </Typography>
                                    <Typography className={styles.titLabel} sx={{ whiteSpace: "normal", textAlign: "justify", lineHeight: "1.5",paddingRight: "15px" }}>
                                        {label.description}
                                    </Typography>
                                </Grid2>
                            </Grid2>
                        ))}
                    </Grid2>
                )}
            </Grid2>
        </div>
    );
};

export default IssueDisclosures;